import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "İnşaat sonrası temizlik hizmetleri",
  heroDescription: "Adana'da inşaat sonrası temizlik hizmetiyle tadilat ve inşaat kalıntılarından arındırılmış kullanıma hazır alanlar.",
  description: "İnşaat veya tadilat sonrası alanlarda toz, harç kalıntısı, boya izi ve genel kir yoğunluğu oluşabilir. Day Temizlik Adana, inşaat sonrası temizlik hizmetinde alanı kullanıma hazır hale getirmeye yönelik detaylı bir temizlik planı uygular. Yeni alanınızın temiz, düzenli ve konforlu olması için profesyonel çözümler sunuyoruz.",
  scope: [
    "İnşaat tozu temizliği",
    "Zemin temizliği",
    "Cam ve uygun yüzey temizliği",
    "Banyo ve mutfak alanlarının temizliği",
    "Kapı, pencere ve dolap dış yüzey temizliği",
    "Kullanıma hazır teslim süreci",
  ],
  forWho: [
    "Yeni ev sahipleri",
    "Tadilat sonrası temizlik isteyenler",
    "İnşaat firmaları",
    "Müteahhitler",
    "Kiracılar",
  ],
  process: [
    "Alanı yerinde görerek inşaat kalıntısı ve kir yoğunluğunu değerlendiriyoruz.",
    "Yapı malzemelerine uygun temizlik maddeleri ve ekipmanları belirliyoruz.",
    "Detaylı temizlik planı hazırlıyoruz.",
    "Profesyonel ekibimizle temizlik sürecini uyguluyoruz.",
    "Son kontrolü yaparak alanı size temiz ve kullanıma hazır teslim ediyoruz.",
  ],
  whyProfessional: [
    "İnşaat tozu ve kalıntıları ev tipi temizlikle çıkmayabilir.",
    "Profesyonel ekipman ve malzemelerle daha etkili sonuç alınır.",
    "Yeni alanınız hemen kullanıma hazır hale getirilir.",
    "Detaylı temizlik sayesinde sağlıklı bir yaşam alanı oluşur.",
    "Zamanında teslim sayesinde planlarınız aksamaz.",
  ],
  relatedServices: [
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
    { title: "Ofis Temizliği", path: "/hizmetlerimiz/ofis-ve-is-yeri-temizligi" },
    { title: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama" },
  ],
  faqs: [
    { question: "İnşaat sonrası temizlikte neler yapılır?", answer: "İnşaat tozu temizliği, zemin temizliği, cam ve yüzey temizliği, banyo ve mutfak temizliği, kapı ve pencere temizliği yapılır." },
    { question: "İnşaat sonrası temizlik ne kadar sürer?", answer: "Alanın büyüklüğüne ve kalıntı yoğunluğuna göre değişir. Genellikle 1-2 gün sürebilir." },
    { question: "Fiyat nasıl belirlenir?", answer: "Alan büyüklüğü, inşaat kalıntısı durumu ve hizmet kapsamına göre fiyat belirlenir." },
  ],
  ctaText: "Yeni alanınızı temiz ve kullanıma hazır teslim almanız için randevu oluşturun.",
  heroImage: "/assets/images/insaat-sonrasi-temizlik.jpg",
};

export default function InsaatSonrasiTemizlikPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}